@if (initialized) {
    <div class="cn-data-quality-panel">

        <!-- ===================== COVERAGE KPI ===================== -->
        <div class="grid mb-3">
            <div class="col-12 md:col-4">
                <div class="cn-dq-kpi surface-0 border-1 surface-border border-round p-3 h-full">
                    <div class="text-sm text-600 mb-1">Abdeckungs-Quote</div>
                    @if (loading) {
                        <p-skeleton height="2.5rem" width="80%"></p-skeleton>
                    } @else if (getCoveragePercent() != null) {
                        <div class="text-3xl font-bold text-primary">
                            {{ getCoveragePercent() | number:'1.1-1':'de' }} %
                        </div>
                        <div class="text-sm text-600 mt-1">
                            {{ counters.contractsCovered | number:'1.0-0':'de' }}
                            /
                            {{ counters.contractsTotal | number:'1.0-0':'de' }}
                            Verträge
                        </div>
                    } @else {
                        <div class="text-600">Keine Abdeckungsdaten</div>
                    }
                </div>
            </div>

            <div class="col-6 md:col-4">
                <div class="cn-dq-kpi surface-0 border-1 surface-border border-round p-3 h-full">
                    <div class="text-sm text-600 mb-1">Unvollständige Basis</div>
                    @if (loading) {
                        <p-skeleton height="2.5rem" width="60%"></p-skeleton>
                    } @else {
                        <div class="text-3xl font-bold text-orange-500">
                            {{ (counters?.incompleteBaseCount ?? 0) | number:'1.0-0':'de' }}
                        </div>
                    }
                </div>
            </div>

            <div class="col-6 md:col-4">
                <div class="cn-dq-kpi surface-0 border-1 surface-border border-round p-3 h-full">
                    <div class="text-sm text-600 mb-1">Nicht zugeordnet</div>
                    @if (loading) {
                        <p-skeleton height="2.5rem" width="60%"></p-skeleton>
                    } @else {
                        <div class="text-3xl font-bold text-red-500">
                            {{ (counters?.unmatchedCount ?? 0) | number:'1.0-0':'de' }}
                        </div>
                    }
                </div>
            </div>
        </div>

        <!-- ===================== ERROR STATE ===================== -->
        @if (errorMessage) {
            <p-message severity="error" class="block mb-3" [text]="errorMessage"></p-message>
        }

        <!-- ===================== STATUS FILTER ===================== -->
        <div class="flex align-items-center gap-2 mb-3 flex-wrap">
            <p-button label="Alle"
                      [outlined]="activeStatusFilter !== 'ALL'"
                      size="small"
                      (onClick)="setStatusFilter('ALL')">
            </p-button>
            <p-button label="Unvollständige Basis"
                      severity="warn"
                      [outlined]="activeStatusFilter !== 'INCOMPLETE_BASE'"
                      size="small"
                      (onClick)="setStatusFilter('INCOMPLETE_BASE')">
            </p-button>
            <p-button label="Nicht zugeordnet"
                      severity="danger"
                      [outlined]="activeStatusFilter !== 'UNMATCHED'"
                      size="small"
                      (onClick)="setStatusFilter('UNMATCHED')">
            </p-button>
        </div>

        <!-- ===================== SERVER-PAGED LIST ===================== -->
        <!-- mvs-widget paginates server-side and renders status badges from enum uiColor.
             Empty state ("Keine Daten vorhanden") and loading skeleton are handled by the widget. -->
        @if (expectationWidget) {
            <mvs-widget
                    [widgetData]="expectationWidget"
                    (onObjectSelect)="handleJumpToContract($event)">
            </mvs-widget>
        }

    </div>
}
